import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Action, Content, ImageWrapper, Page404Content, Page404Styled, Subtitle, Title } from "../Page404/Page404.styled";
import Icon404 from "../../../commons/assets/Icon404.png";
import Footer from "../../../components/Footer/Empathy";

const PageForbidden = () => {
  let navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Page404Styled>
      <Page404Content>
        <ImageWrapper>
          <img src={Icon404} alt="404"/>
        </ImageWrapper>
        <Content>
          <Title>{t('error')}</Title>
          <Subtitle>{t('not-allowed')}</Subtitle>
          <div>
            <Action onClick={() => navigate(-1)}>
              {t('go-back-to-the-previous-page')}
            </Action>
          </div>
        </Content>
      </Page404Content>
      <Footer></Footer>
    </Page404Styled>
  );
};

export default PageForbidden;
